import {
  ContractorDetailsMutations,
  ContractorDetailsActions,
  ContractorDetailsGetters
} from './contractor-details.keys';
import { contractorDetailsService } from './contractor-details.service';
import { attachmentService } from '../../../../components/attachments/attachment.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
import i18n from '@/i18n';
import router from '@/router';

export const getDefaultState = () => {
  return {
    isLoading: true,
    isOnScreenContractorModified: false,
    isLoadingAttachments: false,
    isAssignmentsLoading: false,
    currentContractor: {},
    contractorValidationErrors: {},
    contractorAssignmentSortOrder: {
      sortBy: 'payroll_number',
      sortDirection: 'asc'
    },
    currentContractorAssignments: [],
    currentContractorAttachments: [],
    currentContractorHistories: [],
    currentContractorDepositSlips: []
    /*
    // For mock-up purposes only
    currentContractor: {
      id: 1,
      reference_number: '5LN9QK',
      created_at: '2019-08-14T18:36:59.027Z',
      created_by_id: 0,
      created_comment: '',
      entity: 'INC',
      sin: '987654321',
      ssn: '',
      sin_expiry: new Date(2020, 11, 31),
      pay_to_name: 'AA Inc.',
      payroll_number: '1234',
      effective_date: null,
      user_id: 1,
      aoda_code: '',
      is_aoda: false,
      backcheck_date: null,
      health_and_safety_date: null,
      workplace_violence_date: null,
      whmis_date: null,
      whmis_ghs_date: null,
      is_verified: false,
      hst: '',
      gst: '',
      qst: '',
      is_cpp: 'false',
      supplier_id: null,
      is_ibm: false,
      general_comments: '',
      source: 'Linked In',
      user: {
        id: 1,
        username: 'alicea',
        first_name: 'Alice',
        last_name: 'Abbot',
        is_approver: false,
        is_contractor: true,
        email: 'alicea@example.com',
        reference_number: 'QGL5QL',
        preferred_name: '',
        is_active: true,
        is_client: false,
        is_supplier: false,
        is_tesemployee: false,
        email_alt: '',
        phone1: '(416)123-4567',
        phone1_type: 'MOBILE',
        phone2: '',
        phone2_type: null,
        phone3: '',
        phone3_type: null,
        address_id: null,
        created_at: '2019-08-14T18:36:58.888Z',
        created_by_id: 0,
        address: {
          id: 1,
          line1: '123 fake st',
          line2: 'unit 500',
          city: 'Toronto',
          postal_code: 'q1w2e3',
          province_abbr: 'ON'
        }
      }
    }
*/
  };
};

export const contractorDetailsStore = {
  state: getDefaultState(),
  getters: {
    [ContractorDetailsGetters.IsAssignmentsLoading]: state => {
      return state.isAssignmentsLoading;
    },
    [ContractorDetailsGetters.CurrentContractor]: state => {
      return state.currentContractor;
    },
    [ContractorDetailsGetters.ContractorAssignmentsSortOrder]: state => {
      return state.contractorAssignmentSortOrder;
    },
    [ContractorDetailsGetters.CurrentContractorAssignments]: state => {
      return state.currentContractorAssignments;
    },
    [ContractorDetailsGetters.CurrentContractorHistories]: state => {
      return state.currentContractorHistories;
    },
    [ContractorDetailsGetters.SelectedHistoryRecord]: state => assignmentId => {
      return state.currentContractorHistories.filter(
        historyRecord => historyRecord.id === assignmentId
      )[0];
    },
    [ContractorDetailsGetters.CurrentContractorAttachments]: state =>
      state.currentContractorAttachments,
    [ContractorDetailsGetters.CurrentContractorDepositSlips]: state =>
      state.currentContractorDepositSlips,
    [ContractorDetailsGetters.ContractorValidationErrors]: state => state.contractorValidationErrors
  },
  mutations: {
    [ContractorDetailsMutations.SetAssignmentsLoading]: state => {
      state.isAssignmentsLoading = !state.isAssignmentsLoading;
    },
    [ContractorDetailsMutations.ResetContractorState]: function(state) {
      Object.assign(state, getDefaultState());
    },
    [ContractorDetailsMutations.SetLoading]: (state, isLoading = true) => {
      state.isLoading = isLoading;
    },
    [ContractorDetailsMutations.RetrieveContractorSuccess]: (state, contractor) => {
      state.currentContractor = contractor;
      state.isOnScreenContractorModified = false;
    },
    [ContractorDetailsMutations.SaveContractorSuccess]: (state, contractor) => {
      state.currentContractor = contractor;
      state.isOnScreenContractorModified = false;
    },

    [ContractorDetailsMutations.SetContractorValidationErrors]: (state, errors) => {
      state.contractorValidationErrors = errors;
    },
    [ContractorDetailsMutations.SetContractorAssignmentSortOrder]: (state, sortOrder) => {
      state.contractorAssignmentSortOrder = sortOrder;
    },
    [ContractorDetailsMutations.SetContractorAssignments]: (state, assignments) => {
      state.currentContractorAssignments = assignments;
    },
    [ContractorDetailsMutations.SetContractorHistories]: (state, histories) => {
      state.currentContractorHistories = histories;
    },
    [ContractorDetailsMutations.SetContractorDepositSlips]: (state, depositSlips) => {
      state.currentContractorDepositSlips = depositSlips;
    },
    [ContractorDetailsMutations.RetrieveContractorAttachmentsSuccess]: (state, attachments) => {
      state.currentContractorAttachments = attachments;
    }
  },

  actions: {
    [ContractorDetailsActions.ResetCurrentContractor]: function({ commit, dispatch }) {
      dispatch(TolErrorsActions.ClearAll);
      commit(ContractorDetailsMutations.ResetContractorState);
    },
    [ContractorDetailsActions.RetrieveContractor]: ({ commit, dispatch }, reference_number) => {
      commit(ContractorDetailsMutations.SetLoading, true);
      contractorDetailsService
        .retrieveContractor(reference_number)
        .then(contractor => {
          commit(ContractorDetailsMutations.RetrieveContractorSuccess, contractor);
          dispatch(ContractorDetailsActions.RetrieveContractorAttachments, reference_number);
          dispatch(ContractorDetailsActions.RetrieveContractorAssignemnts, reference_number);
          dispatch(ContractorDetailsActions.RetrieveContractorHistories, reference_number);
          dispatch(ContractorDetailsActions.RetrieveContractorDepositSlips, reference_number);
        })
        .then(() => {
          dispatch(TolErrorsActions.ClearAll);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('contractor.details.errors.retrieveContractor')
          });
        });
      commit(ContractorDetailsMutations.SetLoading, false);
    },
    [ContractorDetailsActions.RetrieveContractorAttachments]: ({ commit }, referenceNumber) => {
      return attachmentService.getAttachments(referenceNumber, 'CONTRACTOR').then(response => {
        commit(ContractorDetailsMutations.RetrieveContractorAttachmentsSuccess, response.data);
      });
    },
    [ContractorDetailsActions.RetrieveContractorAssignemnts]: (
      { commit, state },
      reference_number
    ) => {
      commit(ContractorDetailsMutations.SetAssignmentsLoading);
      return contractorDetailsService
        .retrieveContractorAssignments(reference_number, state.contractorAssignmentSortOrder)
        .then(assignments => {
          commit(ContractorDetailsMutations.SetContractorAssignments, assignments);
        })
        .then(() => commit(ContractorDetailsMutations.SetAssignmentsLoading));
    },

    [ContractorDetailsActions.RetrieveContractorHistories]: ({ commit }, reference_number) => {
      return contractorDetailsService
        .retrieveContractorHistories(reference_number)
        .then(histories => {
          commit(ContractorDetailsMutations.SetContractorHistories, histories);
        });
    },
    [ContractorDetailsActions.RetrieveContractorDepositSlips]: ({ commit }, reference_number) => {
      return contractorDetailsService
        .retrieveContractorDepositSlips(reference_number)
        .then(depositSlips => {
          commit(ContractorDetailsMutations.SetContractorDepositSlips, depositSlips);
        });
    },

    [ContractorDetailsActions.SetContractorAssignmentsSortOrder]: (
      { state, commit, dispatch },
      sortOrder
    ) => {
      commit(ContractorDetailsMutations.SetContractorAssignmentSortOrder, sortOrder);
      dispatch(
        ContractorDetailsActions.RetrieveContractorAssignemnts,
        state.currentContractor.reference_number
      );
    },

    [ContractorDetailsActions.UpdateContractorValidationErrors]: ({ commit }, errors = {}) => {
      commit(ContractorDetailsMutations.SetContractorValidationErrors, errors);
    },

    [ContractorDetailsActions.SaveContractor]: ({ commit, dispatch }, params) => {
      commit(ContractorDetailsMutations.SetLoading);

      let { contractorData, action } = params;

      return contractorDetailsService
        .saveContractor(contractorData, action)
        .then(status => {
          if (status.message === 'success') {
            dispatch(ContractorDetailsActions.UpdateContractorValidationErrors);
            dispatch(ContractorDetailsActions.RetrieveContractor, status.data);
            dispatch(TolMessagesActions.SetMessages, {
              text: i18n.t('contractor.details.message.success')
            });
            router.replace({ path: `/contractors/${status.data}` }).catch(() => {});
          } else {
            dispatch(ContractorDetailsActions.UpdateContractorValidationErrors, status.errors);
            const messages = Object.values(status.errors);
            let items = [];
            for (let item of messages) {
              items = items.concat(item);
            }
            dispatch(TolErrorsActions.SetError, { items });
          }
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    }
  }
};
